<template>
    <div>
        <ViewHealth  v-if="!!item" @success="alertSuccess"></ViewHealth>

        <health-table
            title="Users"
            @addHealth="showHealthModal"
            ref="table"
        ></health-table>
        
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import HealthTable from './HealthTable'
import ViewHealth from './ViewHealth'
// import CreateVehicleForm from './CreateVehicleForm'

export default {
    name: 'Health',
    mixins: [popupMixins, permissionsMixins],
    components: {
        HealthTable,
        ViewHealth,
    },
    data: () => {
        return {
            item: null,
        }
    },

    methods: {
        alertSuccess(action) {
            console.log("asdasda",action)
            console.log(this.item)
            this.genericToast(
                this.componentName,
                action,
                'success',
                `${name} has been succcessfully ${action.toLowerCase()}`
            )
            //this.doToast('Success', `Item ${action}!`, 'success')
            this.item = null
            this.$refs.table.doSearch()
        },
        showHealthModal() {
            this.$refs.createHealth.showModal()
        },
        // created() {
        //     this.doToast('Created!', 'Vehicle Created', 'success')
        //     this.$refs.table.doSearch()
        //     this.$refs.createVehicle.hideModal()
        // },
        handleError(error) {
            this.doToast(this.$translate('error'), error.message, 'danger')
        },
    },
}
</script>
<style></style>
